import { Injectable } from '@angular/core';

import { Action, Selector, State, StateContext } from '@ngxs/store';

import { CognitoAccessToken, CognitoAuthenticated, CognitoIdToken } from '../action/cognito.action';
import { CognitoStateModel } from '../models/cognito.state.model';

@State<CognitoStateModel>({
  name: 'CognitoStateModel',
  defaults: new CognitoStateModel()
})
@Injectable()
export class CognitoState {
  @Selector()
  static getIsAuthenticated(state: CognitoStateModel): boolean {
    return state?.isAuthenticated;
  }

  @Selector()
  static getIdToken(state: CognitoStateModel): string {
    return state?.idToken;
  }

  @Selector()
  static getAccesToken(state: CognitoStateModel): string {
    return state?.accessToken;
  }

  @Action(CognitoAuthenticated)
  cognitoAuthenticated({ getState, patchState }: StateContext<CognitoStateModel>, cognitoAuthenticated: CognitoAuthenticated): void {
    const isAuthenticated = cognitoAuthenticated.isAuthenticated;

    /*trovo la prestazione nello store*/
    const state = getState();

    patchState({
      isAuthenticated: isAuthenticated
    });
  }

  @Action(CognitoIdToken)
  cognitoIdToken({ getState, patchState }: StateContext<CognitoStateModel>, cognitoIdToken: CognitoIdToken): void {
    const idToken = cognitoIdToken.idToken;

    /*trovo la prestazione nello store*/
    const state = getState();

    patchState({
      idToken: idToken
    });
  }

  @Action(CognitoAccessToken)
  cognitoAccessToken({ getState, patchState }: StateContext<CognitoStateModel>, cognitoAccessToken: CognitoAccessToken): void {
    const accessToken = cognitoAccessToken.accessToken;

    /*trovo la prestazione nello store*/
    const state = getState();

    patchState({
      accessToken: accessToken
    });
  }
}
